if (!customElements.get("announcement-bar-slider")) {
  customElements.define(
    "announcement-bar-slider",
    class AnnouncementBarSlider extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        // Wait for Splide to load if using defer
        if (window.Splide) {
          this.initSlider();
        } else {
          document.addEventListener("splide:ready", () => this.initSlider());
        }
      }

      initSlider() {
        const sliderElement = this.querySelector(
          '[data-splide-element="slider"]',
        );
        if (!sliderElement) return;

        const speed = parseFloat(this.dataset.speed) || 0.5;
        const desktopPerPage = parseFloat(this.dataset.perPageDesktop) || 5;
        const mobilePerPage = parseFloat(this.dataset.perPageMobile) || 1.5;

        const splide = new Splide(sliderElement, {
          type: "loop",
          drag: "free",
          focus: "center",
          pagination: false,
          arrows: false,
          autoWidth: true,
          gap: "24px",
          rewind: false,
          trimSpace: false,
          cloneStatus: true,
          autoScroll: {
            speed: speed,
            pauseOnHover: true,
            pauseOnFocus: false,
          },
          breakpoints: {
            767: {
              perPage: mobilePerPage,
            },
          },
        });

        // const autoScrollExt = window.Splide?.Extensions?.AutoScroll;
        // splide.mount(autoScrollExt ? { AutoScroll: autoScrollExt } : {});

        var autoScrollExt =
          (window.Splide &&
            window.Splide.Extensions &&
            window.Splide.Extensions.AutoScroll) ||
          (window.splide &&
            window.splide.Extensions &&
            window.splide.Extensions.AutoScroll);

        splide.mount(autoScrollExt ? { AutoScroll: autoScrollExt } : {});
      }
    },
  );
}
